module.exports = __webpack_public_path__ + "static/media/mta-logo.6d496ee2.png";